import { Component } from '@angular/core';
import { QuarantinedDocument } from '../../constants/quarantined-document.constants';
import { QuarantinedDocumentsService } from '../../services/quarantined-documents.service';
import { LabelConstants } from '../../../shared/constants/label-constants';

@Component({
  selector: 'app-my-quarantined-documents',
  templateUrl: './my-quarantined-documents.component.html',
  styleUrls: ['./my-quarantined-documents.component.scss']
})
export class MyQuarantinedDocumentsComponent {
  topBarTitle: string = QuarantinedDocument.MyQuarantinedDocuments_TopBarTitle;
  showAllLabel: string = QuarantinedDocument.MyQuarantinedDocuments_ShowAllLabel;
  isIncludeAll = QuarantinedDocument.MyQuarantinedDocuments_IsIncludeAll;
  showInformationIconCheckbox = QuarantinedDocument.MyQuarantinedDocuments_ShowInformationIconCheckbox;
  showAllToolTip: string = QuarantinedDocument.MyQuarantinedDocuments_CheckBoxHoverToolTip;
  quarantinedDocuments: any[] = [];
  panelListType: string = QuarantinedDocument.MyQuarantinedDocuments_PanelListType;
  showLoader: boolean = true;
  isScreenAccessible: boolean = true;
  errorMessage !: string;
  displayShowAllButton: boolean = true;
  displayShowAllLabel: boolean = true;

  constructor(private quarantinedDocumentService: QuarantinedDocumentsService) {
  }

  ngOnInit(): void {
    this.getPanelListData(this.isIncludeAll);
  }


  includeInactive(isIncludeAll: boolean) {    
    this.getPanelListData(isIncludeAll);
  }

  getPanelListData(isIncludeAll: boolean) {
    this.showLoader = true;
    this.quarantinedDocumentService.getMyQuarantinedDocuments(isIncludeAll).subscribe({
      error: (err) => {
        if (err.status === LabelConstants.Forbidden_StatusCode) {
          this.errorMessage = err.error.detail;
        }
        this.isScreenAccessible = false;
        this.showLoader = false;
      },
      next: (serviceData) => {
        this.quarantinedDocuments = serviceData;
        this.showLoader = false;
      }
    });
  }

}
